import { Injectable } from '@angular/core';
import { Category } from '../models/new/category';

@Injectable({
	providedIn: 'root'
})
export class CategoryMapper {
	constructor() {}

	toCategory(category: any) {
		return new Category({
			id: category.id,
			name: category.name
		});
	}
}
